/**
 * home页面的所有数据
 */
import { getViewHomeMediaList } from '@/api/ad'

export default {
  namespaced: true,
  state: {
    isNeedUpdate: false, // 我的书架弹框非会员用户选择了书籍后实时更新首页我的书架数据
    userWorkBook: [],
    mediaList: {
      banner: null,
      popup: null,
      across: null,
      adIcon: null
    },
    banners: [],
    modals: []
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    INIT_USER_WORK_BOOK: (state, list) => {
      state.userWorkBook = list
    },
    SET_MEDIA_LIST: (state, { banner, popup, across, adIcon }) => {
      state.mediaList = { banner, popup, across, adIcon }
    },
    SET_BANNERS: (state, list) => {
      state.banners = list
    },
    SET_MODALS: (state, modals) => {
      state.modals = modals
    },
    SET_IS_NEED_UPDATE: (state, value) => {
      state.isNeedUpdate = value
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    // 获取媒体列表
    async initMediaList({ commit, rootGetters }, vip) {
      const { banner, popup, across, adIcon } = await getViewHomeMediaList({ vip })

      commit('SET_MEDIA_LIST', { banner, popup, across, adIcon })
    },
    // 获取banner sv
    async initBanners({ commit, state }) {
      try {
        const { banner } = state.mediaList

        commit('SET_BANNERS', banner.details)
      } catch (e) {}
    },
    // 获取首屏弹窗
    initModals({ commit, state, rootGetters }) {
      try {
        const { popup } = state.mediaList

        commit('SET_MODALS', popup.details)
      } catch (e) {}
    },
    async initSv({ dispatch }) {
      await dispatch('initMediaList', 'SV')
      await dispatch('initBanners')
      await dispatch('initModals')
    },
    async initNv({ dispatch }) {
      await dispatch('initMediaList', 'NV')
      await dispatch('initBanners')
      await dispatch('initModals')
    }
  },
  getters: {
    banners: (state) => state.banners,
    adIcon: (state) => state.mediaList.adIcon,
    modal: (state) => {
      const m = state.modals[0]
      if (m) {
        return {
          imageUrl: m.imgPath,
          link: m.urlPath,
          needAdPrint: m.externalOrg,
          deviceType: m.devices,
          vip: m.authes
        }
      } else {
        return null
      }
    },
    propagate: (state) => state.mediaList.across && state.mediaList.across.details[0]
  }
}
